import { render, staticRenderFns } from "./AiproxyProviderIcon.vue?vue&type=template&id=eb6b84aa&scoped=true"
import script from "./AiproxyProviderIcon.vue?vue&type=script&lang=js"
export * from "./AiproxyProviderIcon.vue?vue&type=script&lang=js"
import style0 from "./AiproxyProviderIcon.vue?vue&type=style&index=0&id=eb6b84aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6b84aa",
  null
  
)

export default component.exports